import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './chemicalsIntro.module.css';
import { Autoplay } from 'swiper/modules';
import SectionTitle from '../../sectionTitle/SectionTitle';


export default function ChemicalsIntro({ data }) {

  return (
    <div className={`${styles.container} container-fluid`}>
      <SectionTitle title={data?.name} className='text-center' />
      <Swiper
        className={styles.swiper}
        slidesPerView={'auto'}
        loop={true}
        autoplay={{ delay: 2000, }}
        speed={2000}
        spaceBetween={30}
        centeredSlides={window.innerWidth < 576 ? true : false}
        modules={[Autoplay]}
      >
        {data?.products.map(product =>
          <SwiperSlide className={styles.swiperSlide} key={product.id}>
            <img src={product.image} alt={product.name} loading='lazy' />
            <div className='d-flex flex-column'>
              <strong className={`${styles.title} text-truncate`}>{product.name}</strong>
              <strong className={`${styles.company} text-truncate`}>{product.brand}</strong>
            </div>
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  );
}
